import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { sendApi } from "../../apis/Index";

// #ffb7ce #cccccc #fff1f5 #FFB7CF
const OrderSumry = ({ ordered, user }) => {
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmitComment = async () => {
    if (!comment.trim()) {
      toast.error("Please enter a comment");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await sendApi(
        {
          product_id: ordered.product_id,
          text: comment,
        },
        "https://wittynailtip.com/backend/add-review.php",
      );

      if (response.data.success) {
        toast.success("Review submitted successfully!");
        setComment("");
      } else {
        toast.error(response.data.message || "Failed to submit review");
      }
    } catch (error) {
      toast.error("An error occurred while submitting your review");
      console.error("Review submission error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="space-y-6">
      <div className="bg-white border-none rounded-2xl text-summary">
        <div className="p-4 md:p-6 space-y-4">
          <div className="flex justify-between items-start">
            <div>
              <h4 className="font-bold md:text-xl text-lg text-gray-900 mb-1">Order Summary</h4>
              <p className="text-gray-500 md:text-sm text-xs">
                Monitor your goods on our page
              </p>
            </div>
            <h5 className="font-semibold text-[#FFB7CF] tracking-wide px-3 py-1 text-xs md:text-sm bg-[#fff1f5] rounded-full capitalize">
              {ordered.tracking}
            </h5>
          </div>

          <div className="order-summary space-y-3 font-medium text-sm md:text-base text-gray-600 bg-gray-50 p-4 rounded-xl border border-gray-100">
            <div className="flex w-full justify-between items-center">
              <h6>Subtotal ({ordered.quantity} items)</h6>
              <h6 className="text-gray-900 font-semibold">${ordered?.initial_price?.unit_amount}</h6>
            </div>

            <div className="flex w-full justify-between items-center pt-3 border-t border-gray-200">
              <h6 className="font-bold text-gray-900">Total</h6>
              <h6 className="font-bold text-gray-900 text-lg">${ordered.final_price}</h6>
            </div>
          </div>
          
          <div className="pt-2 text-sm font-medium">
            <div className="flex w-full justify-between items-center">
              <h6 className="text-gray-500">Paid by customer</h6>
              <h6 className="text-gray-900">${ordered?.initial_price?.unit_amount}</h6>
            </div>
          </div>
        </div>

        {!ordered.tracking === "paid" && (
          <div className="font-medium md:text-sm text-xs flex flex-col md:flex-row justify-between items-center w-full px-4 md:px-6 py-4 bg-[#fff1f5] rounded-b-2xl border-t border-red-50 gap-4">
            <p className="text-gray-600 text-center md:text-left">
              Review your order at glance in our order summary page
            </p>
            <div className="flex items-center gap-2 w-full md:w-auto">
              <button className="flex-1 md:flex-none px-4 bg-white border border-gray-200 text-gray-700 rounded-full py-2 hover:bg-gray-50 transition-colors shadow-sm">
                Send Invoice
              </button>
              <button className="flex-1 md:flex-none px-4 bg-[#FFB7CF] hover:bg-[#ff9cbb] rounded-full py-2 text-white transition-colors shadow-sm">
                Confirm Payment
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="timeline bg-white rounded-2xl p-4 md:p-6 border-none">
        <div className="text-sm">
          <h4 className="font-bold md:text-xl text-lg text-gray-900 mb-1">Leave a Review</h4>
          <p className="text-gray-500 md:text-sm text-xs mb-4">
            How was your order? Let us know what you think!
          </p>
          
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 bg-gray-200 rounded-full overflow-hidden">
              <img src="/logo.webp" alt="user" className="w-full h-full object-cover" />
            </div>
            <h6 className="font-semibold text-gray-900 text-sm">
              {user?.full_name}
            </h6>
          </div>

          <textarea
            name="comment"
            id="comment"
            rows="4"
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
            }}
            disabled={isSubmitting}
            className="w-full bg-gray-50 rounded-xl p-4 outline-none border border-gray-200 focus:border-[#FFB7CF] focus:ring-2 focus:ring-[#FFB7CF]/20 transition-all resize-none text-gray-700"
            placeholder="Write your thoughts here..."
          ></textarea>

          <div className="flex justify-end mt-3">
            <button
              type="button"
              onClick={handleSubmitComment}
              disabled={isSubmitting || !comment.trim()}
              className="bg-gray-900 hover:bg-black text-white px-6 py-2.5 rounded-full disabled:opacity-50 disabled:cursor-not-allowed text-sm font-semibold transition-all shadow-md hover:-translate-y-0.5"
            >
              {isSubmitting ? "Submitting..." : "Post Review"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSumry;
